export default __webpack_public_path__ + "static/media/chart-fi-analytics.038a4b30.svg";